import { nextEvent } from './async';

export async function online(signal?: AbortSignal) {
  while (!navigator.onLine) {
    // eslint-disable-next-line no-await-in-loop
    await nextEvent(window, 'online', signal);
  }
  return true;
}
